module.exports = __webpack_public_path__ + "static/vie_privee-cc3d776207eb4cf1ccfc875195dc3dac.jpg";